import React, { useEffect, useState } from "react";
import "./PortfolioModal.scss";
import { Form, Modal, DatePicker, Skeleton, Button } from "antd";
import CustomSelect from "../../../Reuseable/Select/Select";
import InputField from "../../../Reuseable/InputField/InputField";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import DragUpload from "../../../Reuseable/DragUpload/DragUpload";
import logo from "../../../assets/Icons/fileLogo.svg";
import download from "../../../assets/Icons/downloadIconPortfolio.svg";
import trash from "../../../assets/Icons/dustbinPortfolio.svg";
import completed from "../../../assets/Icons/completed.svg";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { fetchPortfolioFiles } from "../../../store/portfolioSlice";
import { ReactComponent as Down } from "../../../assets/Icons/DownArrow.svg";
import { DeleteTwoTone } from "@ant-design/icons";
import {
  deletePortfolioFile,
  downloadAllFiles,
} from "../../../assets/api/portfolio";
import toast from "react-hot-toast";

const PortfolioModal = ({
  isOpen,
  onClose,
  userData = {},
  onSave,
  mode = "add",
  setUserData,
  setFile,
  file,
  load,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);
  const { uploaded_files, uploaded_files_loading } = useSelector(
    (state) => state.portfolio,
  );

  useEffect(() => {
    if (mode === "edit" && userData) {
      form.setFieldsValue({
        name: userData.name,
        totalCases: userData.totalCases,
        totalPOS: userData.totalPOS,
        total_tos: userData.total_tos,
      });
    } else if (!isOpen) {
      form.resetFields();
    }
  }, [mode, userData, form]);

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        onSave?.(values);
        // onClose();
      })
      .catch((info) => {
        console.error("Validation Failed:", info);
      });
  };

  useEffect(() => {
    if (mode === "edit" && userData?.id && !userData?.file) {
      dispatch(fetchPortfolioFiles({ portfolio_id: userData?.id }));
    }
  }, [dispatch, userData]);

  const handleDeleteFile = async (id) => {
    try {
      setLoading(id);
      const res = await deletePortfolioFile(
        {
          body: {
            file_id: id,
          },
          portfolio_id: userData?.id,
        },
        token,
      );

      if (res?.status === 200) {
        toast.success(res?.data?.message);
        setLoading(null);
        dispatch(fetchPortfolioFiles({ portfolio_id: userData?.id }));
      }
    } catch (error) {
      setLoading(null);
      console.log(error, "error");
    }
  };

  const handleDownloadFile = (file_url) => {
    const link = document.createElement("a");
    link.href = file_url;
    link.setAttribute("download", "file");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadFileAll = async () => {
    try {
      setLoadingFile(true);
      const res = await downloadAllFiles(token, userData?.id);
      if (res?.status === 200) {
        let url = res?.data?.data?.download_url;
        handleDownloadFile(url);
        setLoadingFile(false);
      }
    } catch (error) {
      setLoadingFile(false);
    }
  };

  return (
    <Modal
      className="modalMainContainer"
      title={mode === "edit" ? "Edit portfolio" : "Add new portfolio"}
      open={isOpen}
      onCancel={() => {
        onClose();
        setFile(null);
      }}
      footer={null}
      centered
    >
      <div className="mainWrapperForModal">
        <Form form={form} layout="vertical">
          <div className="selectorWrapper">
            <div className="wrappedContainer">
              <Form.Item
                name="name"
                className="formItem nameInputSect"
                rules={[{ required: true, message: "Please enter name" }]}
              >
                <InputField label="Name" placeholder="Enter name" />
              </Form.Item>
            </div>

            <div className="wrappedContainer">
              <Form.Item
                name="totalCases"
                className="formItem"
                rules={[
                  { required: true, message: "Please enter total cases" },
                ]}
              >
                <InputField
                  label="Total Cases"
                  placeholder="Enter total cases"
                />
              </Form.Item>
            </div>
          </div>

          <div className="selectorWrapper">
            <Form.Item
              name="totalPOS"
              className="formItem"
              rules={[{ required: true, message: "Please enter total POS" }]}
            >
              <InputField label="Total POS" placeholder="₹0.00 Cr" />
            </Form.Item>
            <Form.Item
              name="total_tos"
              className="formItem"
              rules={[{ required: true, message: "Please enter Total TOS" }]}
            >
              <InputField label="Total TOS" placeholder="₹0.00 Cr" />
            </Form.Item>
          </div>

          {/* Only render uploaded files if in edit mode */}
          {mode === "edit" && (
            <div className="uploadedFilesWrapper">
              {uploaded_files?.total_files > 0 && (
                <div className="uploadedFilesHeader">
                  <span className="sectionTitle">Uploaded File</span>
                  <button
                    className="downloadAllBtn"
                    onClick={handleDownloadFileAll}
                  >
                    {loadingFile ? "Downloading..." : "Download All"}
                  </button>
                </div>
              )}
              {(uploaded_files?.total_files || uploaded_files_loading) > 0 && (
                <div
                  className="cardWrapper"
                  style={{ maxHeight: "400px", overflow: "auto" }}
                >
                  {(uploaded_files_loading
                    ? Array(4).fill(0)
                    : uploaded_files?.files
                  )?.map((item, index) => (
                    <div className="uploadedFileRow">
                      <div className="fileInfo">
                        <div className="fileLogo">
                          <img src={logo} alt="" />
                          {/* <img src={logo} alt="" /> */}
                        </div>
                        {uploaded_files_loading ? (
                          <Skeleton.Input
                            size="small"
                            active
                            style={{ width: "100%" }}
                          />
                        ) : (
                          <div className="fileName">
                            <span className="titleOfFile">
                              {/* AxisBank_LoanPortfolio_June2025.xlsx */}
                              {item?.file_name}
                            </span>
                            <span className="sizeOfFile">
                              {item?.uploaded_on}
                            </span>
                            {/* 94KB of 94 KB. */}
                          </div>
                        )}
                      </div>
                      <div className="fileActions">
                        <Button
                          className="downloadBtn"
                          onClick={() => handleDownloadFile(item?.file_url)}
                          icon={<img src={download} alt="" />}
                        />
                        <Button
                          loading={loading === item?.id}
                          className="deleteBtn"
                          onClick={() => handleDeleteFile(item?.id)}
                          icon={<img src={trash} alt="" />}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="uploadedFilesGridSection">
                <div className="filesGrid">
                  {userData?.uploadedFiles?.map((file, index) => (
                    <div key={index} className="fileCard">
                      <div className="fileLeft">
                        <img
                          src="/assets/icons/xlsx-icon.svg"
                          alt="file"
                          className="fileIcon"
                        />
                        <div className="fileInfo">
                          <span className="fileName">{file.name}</span>
                          <span className="fileSize">94 KB</span>
                        </div>
                      </div>
                      <div className="fileActions">
                        <button className="iconBtn downloadBtn">⬇️</button>
                        <button className="iconBtn deleteBtn">🗑️</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          {file !== null ? (
            <DragUpload
              label={"Upload more"}
              setFile={setFile}
              readOnly={true}
              file={file?.[0]?.originFileObj}
            />
          ) : (
            <DragUpload
              label={"Upload more"}
              onChange={(file) => setFile?.(file)}
            />
          )}
          <p>Limit 200MB per file | Only XLSX, CSV file</p>
          {/* {mode === "edit" && (
            <div className="cardWrapper">
              <div className="uploadedFileRow ">
                <div className="fileInfo">
                  <div className="fileLogo">
                   
                    <img src={logo} alt="" />
                  </div>
                  <div className="fileName">
                    <span className="titleOfFile">
                      AxisBank_LoanPortfolio_June2025.xlsx
                    </span>
                    <div className="completionDetail">
                      <span className="sizeOfFile"> 94KB of 94 KB.</span>
                      <div className="completed">
                        <img src={completed} alt="" />
                        <p className="successUploadText">Completed</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="fileActions">
                  <button className="deleteBtn">
                    <img src={trash} alt="" />
                  </button>
                </div>
              </div>
            </div>
          )} */}
          <div className="submitBtn">
            <NormalButton type="primary" onClick={handleSave} loading={load}>
              Submit
            </NormalButton>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default PortfolioModal;
